import { render, staticRenderFns } from "./Deworming.vue?vue&type=template&id=e2b04186&scoped=true&"
import script from "./Deworming.vue?vue&type=script&lang=js&"
export * from "./Deworming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b04186",
  null
  
)

export default component.exports